import React, { Component, Fragment } from "react";
import Api from "../../../../Services/Api";
import FlexView from "react-flexview";
import SimpleInput from "../../../../modules/SimpleInput";
import { ACTIVITY_TYPE, HttpStatus, Status } from "../../../common/Constants";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../modules/SimpleDDL";
import { mapToDDL, mapToObjectDDL } from "../../../common/mapper";
import * as R from "ramda";
import ToggleButton from "react-toggle-button";
import M from "moment";
import { fetchDataAsync } from "../../../../Services/Utils";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class MasterPromoH2Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllSelected: false,
      isAreaSelected: false,
      isSpecificSelected: false,
      confirmChangePromoType: false,
      tempPromoType: null,
      dataCabang: [],
      dataLeasing: [],
    };
  }

  componentDidMount = async () => {
    this.fetchDataCabang();
  };

  componentDidUpdate = (prevProps) => {
    if (
      this.props.controls.promoTypeLocation.value !==
      prevProps.controls.promoTypeLocation.value
    ) {
      if (this.props.controls.promoTypeLocation.value === "ALL") {
        this.setState((prevValue) => ({
          ...prevValue,
          isAllSelected: true,
          isAreaSelected: false,
          isSpecificSelected: false,
        }));
      }
      if (this.props.controls.promoTypeLocation.value === "WILAYAH") {
        this.setState((prevValue) => ({
          ...prevValue,
          isAreaSelected: true,
          isAllSelected: false,
          isSpecificSelected: false,
        }));
      }
      if (this.props.controls.promoTypeLocation.value === "CABANG") {
        this.setState((prevValue) => ({
          ...prevValue,
          isSpecificSelected: true,
          isAreaSelected: false,
          isAllSelected: false,
        }));
      }
    }
  };

  handleSelectedBranch = (e, type) => {
    const isChecked = e.target.checked;

    this.props.setValue("promoTypeLocation", isChecked ? type : "");
    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isAreaSelected: false,
        isSpecificSelected: false,
      }));
      this.props.setValue("cabangCode", []);
      this.props.setValue("area", []);
      this.props.setValue("idWilayah", null);
    }

    if (type === "WILAYAH") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAreaSelected: isChecked,
        isAllSelected: false,
        isSpecificSelected: false,
      }));
      this.props.setValue("cabangCode", []);
      if (!isChecked) {
        this.props.setValue("idWilayah", null);
        this.props.setValue("area", []);
      }
    }

    if (type === "CABANG") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAreaSelected: false,
        isAllSelected: false,
      }));
      this.props.setValue("area", []);
      this.props.setValue("idWilayah", null);
      if (!isChecked) {
        this.props.setValue("cabangCode", []);
      }
    }
  };

  handleStatus = (status) => {
    this.props.setValue("status", status);
  };

  fetchDataCabang = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: `Master Promo H2`,
      setError: this.props.setError,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const allowedCabang = this.props.menuAccess.map((item) => item.idRefObj);

      const filteredData = res.data.data.filter((item) =>
        allowedCabang.includes(item.kodeCabang)
      );

      this.setState((prevValue) => ({
        ...prevValue,
        dataCabang: filteredData,
      }));
    }
  };

  fetchCabangByArea = async (area) => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterCabang,
      menuName: `Master Promo H2`,
      setError: this.props.setError,
      args: {
        filter: {
          idWilayah: area,
          status: "ACTIVE",
        },
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let { data } = res.data;
      return data.map((cab) => cab.kodeCabang);
    } else {
      return [];
    }
  };

  fetchDataLeasing = async (listKodeCabang = []) => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterLeasing,
      menuName: `Master Promo ${this.props.tab.toUpperCase()}`,
      setError: this.props.setError,
      args: { paramFilters: { listKodeCabang } },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataLeasing: res.data.data,
      }));
    }
  };

  handleChangePromoType = async (value) => {
    this.props.setValue("promoType", value);
    this.props.setValue("dataUnit", []);
    this.setState({ confirmChangePromoType: false });
    if (R.equals(value?.value, "CREDIT")) {
      this.props.triggerLoading();
      let { promoTypeLocation, cabang, wilayah } = this.props.controls;
      let filter = [];
      if (R.equals(promoTypeLocation?.value, "WILAYAH")) {
        filter = await this.fetchCabangByArea(wilayah?.value?.value);
      }
      if (R.equals(promoTypeLocation?.value, "CABANG")) {
        filter = cabang?.value.map((cab) => cab.value);
      }
      await this.fetchDataLeasing(filter);
      this.props.triggerLoading();
    }
  };

  handleChangeArea = async (value) => {
    let { promoType } = this.props.controls;
    this.props.setValue("idWilayah", value);
  };

  handleChangeCabang = async (value) => {
    let { promoType } = this.props.controls;
    this.props.setValue("cabangCode", value);
  };

  handleConfirmPromoType = (value) => {
    let { promoType } = this.props.controls;
    if (R.isEmpty(promoType?.value)) {
      this.handleChangePromoType(value);
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        confirmChangePromoType: !prevValue.confirmChangePromoType,
        tempPromoType: value,
      }));
    }
  };

  render() {
    return (
      <Fragment>
        <div className="flex-1" style={{ marginBottom: "20px" }}>
          <div className="grid grid-3x gap-40px">
            <div id="grid-1" style={{ marginRight: "30px" }}>
              <SimpleInput
                id="input_text_promo_id"
                name="promoServicePartId"
                label="Promo ID"
                style={{ width: 300 }}
                mandatory
                errorMessage={this.props.errors.promoServicePartId}
                value={this.props.controls?.promoServicePartId?.value}
                readOnly
              />
              <SimpleInput
                id="input_text_promo_name"
                name="promoServicePartName"
                label="Nama Promo"
                style={{ width: 300 }}
                mandatory
                errorMessage={this.props.errors.promoServicePartName}
                value={this.props.controls?.promoServicePartName?.value}
                readOnly={this.props.activityType === ACTIVITY_TYPE.VIEW}
                onChange={({ target }) => {
                  this.props.setValue(target.name, target.value);
                }}
              />
              <div>
                <div
                  className="txt-site txt-11 txt-main txt-bold"
                  style={{ marginBottom: 10 }}
                >
                  <h4>
                    Cabang Berlaku<span style={{ color: "red" }}>*</span>
                  </h4>
                </div>
                <FlexView
                  style={{ gap: "20px", marginRight: "20px", marginBottom: 25 }}
                >
                  <SimpleCheckBox
                    id="promoAllCabang"
                    key="promoAllCabang"
                    name="promoAllCabang"
                    label="All"
                    checked={this.state.isAllSelected}
                    onChange={(e) => this.handleSelectedBranch(e, "ALL")}
                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                  />
                  <SimpleCheckBox
                    id="promoArea"
                    key="promoArea"
                    name="promoArea"
                    label="Wilayah"
                    checked={this.state.isAreaSelected}
                    onChange={(e) => this.handleSelectedBranch(e, "WILAYAH")}
                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                  />
                  <SimpleCheckBox
                    id="promoSpecific"
                    key="promoSpecific"
                    name="promoSpecific"
                    label="Spesifik Cabang"
                    checked={this.state.isSpecificSelected}
                    onChange={(e) => this.handleSelectedBranch(e, "CABANG")}
                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                  />
                </FlexView>
                {this.props.errors.promoTypeLocation && (
                  <p className="txt-site txt-11 color-red margin-top-5px">
                    Field belum diisi
                  </p>
                )}
              </div>
              <div style={{ width: 334 }}>
                <SimpleDDL
                  id="select_options_wilayah"
                  name="idWilayah"
                  label="Wilayah"
                  box="search"
                  isClearable
                  mandatory={this.state.isAreaSelected}
                  errorMessage={this.props.errors.idWilayah}
                  readOnly={
                    this.props.activityType === ACTIVITY_TYPE.VIEW
                      ? true
                      : !this.state.isAreaSelected
                  }
                  value={this.props.controls?.idWilayah?.value}
                  options={this.props.dataArea}
                  onChange={(value) => this.handleChangeArea(value)}
                />
              </div>
            </div>
            <div id="grid-2" style={{ marginRight: "30px" }}>
              <div style={{ margin: "5px 0 30px" }}>
                <div
                  className="txt-site txt-11 txt-main txt-bold"
                  style={{ marginBottom: 10 }}
                >
                  <h4>
                    Promo Boleh digabung dengan voucher?
                    <span style={{ color: "red" }}>*</span>
                  </h4>
                </div>

                <FlexView style={{ gap: "20px", marginRight: "20px" }}>
                  {/* Radio: Boleh */}
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 5 }}
                  >
                    <input
                      type="radio"
                      name="combinePromo"
                      value="true"
                      checked={
                        this.props.controls?.combinePromo?.value === true
                      }
                      onChange={() => this.props.setValue("combinePromo", true)}
                      disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                    />
                    Boleh
                  </label>

                  {/* Radio: Tidak Boleh */}
                  <label
                    style={{ display: "flex", alignItems: "center", gap: 5 }}
                  >
                    <input
                      type="radio"
                      name="combinePromo"
                      value="false"
                      checked={
                        this.props.controls?.combinePromo?.value === false ||
                        this.props.controls?.combinePromo?.value === undefined
                      }
                      onChange={() =>
                        this.props.setValue("combinePromo", false)
                      }
                      disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                    />
                    Tidak Boleh
                  </label>
                </FlexView>

                {this.props.errors.combinePromo && (
                  <p className="txt-site txt-11 color-red margin-top-5px">
                    {this.props.errors.combinePromo}
                  </p>
                )}
              </div>
              <div style={{ marginBottom: 73 }}>
                <div className="txt-site txt-11 txt-main txt-bold">
                  <h4>
                    Periode Promo
                    {!this.props.controls?.promoHasGracePeriode?.value && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </h4>
                </div>
                <FlexView
                  vAlignContent="center"
                  style={{ gap: "10px", marginTop: 3 }}
                >
                  <SimpleDate
                    name="promoStartDate"
                    nextdate
                    mandatory={
                      !this.props.controls?.promoHasGracePeriode?.value
                    }
                    date={this.props.controls?.promoStartDate?.value}
                    maxDate={this.props.controls?.promoEndDate?.value}
                    disabled={
                      this.props.activityType === ACTIVITY_TYPE.VIEW ||
                      this.props.controls?.promoHasGracePeriode?.value
                    }
                    errorMessage={this.props.errors.promoStartDate}
                    onChange={(value) =>
                      this.props.setValue(
                        "promoStartDate",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                  <span className="margin-bottom-20px">s/d</span>
                  <SimpleDate
                    name="promoEndDate"
                    backdate
                    mandatory={
                      !this.props.controls?.promoHasGracePeriode?.value
                    }
                    date={this.props.controls?.promoEndDate?.value}
                    minDate={this.props.controls?.promoStartDate?.value}
                    disabled={
                      this.props.activityType === ACTIVITY_TYPE.VIEW ||
                      this.props.controls?.promoHasGracePeriode?.value
                    }
                    errorMessage={this.props.errors.promoEndDate}
                    onChange={(value) =>
                      this.props.setValue(
                        "promoEndDate",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                </FlexView>
              </div>
              <SimpleDDL
                id="select_options_cabang"
                name="cabangCode"
                label="Cabang Berlaku"
                box="multiselect"
                mandatory={this.state.isSpecificSelected}
                errorMessage={this.props.errors.cabangCode}
                readOnly={
                  this.props.activityType === ACTIVITY_TYPE.VIEW
                    ? true
                    : !this.state.isSpecificSelected
                }
                value={this.props.controls?.cabangCode?.value}
                options={this.state.dataCabang.map((item) =>
                  mapToDDL(item.namaDealer, item.kodeCabang)
                )}
                onChange={(value) => this.handleChangeCabang(value)}
              />
            </div>
            <div id="grid-3" style={{ marginLeft: 35 }}>
              <div className="grid grid-2x gap-5px" style={{ width: 320 }}>
                <div id="grid-1">
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <SimpleInput
                      name="promoGracePeriode"
                      label="Grace Period"
                      box="number"
                      mandatory={
                        !this.props.controls?.promoHasGracePeriode?.value
                      }
                      style={{ width: 55 }}
                      value={this.props.controls?.promoGracePeriode?.value}
                      errorMessage={this.props.errors.promoGracePeriode}
                      readOnly={
                        this.props.activityType === ACTIVITY_TYPE.VIEW ||
                        this.props.controls?.promoHasGracePeriode?.value
                      }
                      onValueChange={({ value }) =>
                        this.props.setValue("promoGracePeriode", value)
                      }
                    />

                    <span>hari</span>
                  </div>
                </div>
                <div id="grid-2" style={{ marginTop: 5 }}>
                  <div className="txt-site txt-11 txt-main txt-bold">
                    <h4>No Periode</h4>
                  </div>
                  <SimpleCheckBox
                    id="promoHasGracePeriode"
                    name="promoHasGracePeriode"
                    styles={{ marginTop: "10px" }}
                    disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
                    checked={
                      this.props.controls?.promoHasGracePeriode?.value || false
                    }
                    onChange={() => {
                      const current =
                        this.props.controls?.promoHasGracePeriode?.value;
                      const next = !current;

                      this.props.setValue("promoHasGracePeriode", next);

                      if (next === true) {
                        this.props.setValue("promoGracePeriode", "");
                        this.props.setValue("promoStartDate", null);
                        this.props.setValue("promoEndDate", null);
                      }
                    }}

                    // onChange={() =>
                    //   this.props.setValue(
                    //     "promoHasGracePeriode",
                    //     !this.props.controls?.promoHasGracePeriode?.value
                    //   )
                    // }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {this.state.confirmChangePromoType && (
          <SimpleAlert
            visible={this.state.confirmChangePromoType}
            onClickClose={this.handleConfirmPromoType}
            title={"Information"}
            content={
              "Mengganti Tipe Promo akan menghapus detail promo, apakah anda yakin?"
            }
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton
                  onClick={() =>
                    this.handleChangePromoType(this.state.tempPromoType)
                  }
                >
                  Ya
                </SimpleButton>
                <SimpleButton onClick={this.handleConfirmPromoType}>
                  Tidak
                </SimpleButton>
              </FlexView>
            }
          />
        )}
      </Fragment>
    );
  }
}

export default MasterPromoH2Header;
